<template>
	<div v-if="notify" class="C_im-notify">
		<h5>新消息</h5>
		<a class="icon icon-close" @click="closeNotify"></a>
		<div class="content">
			<template v-if="notify.senderName">
				<span v-if="notify.thumb" class="thumb"><img :src="notify.thumb"></span>
				<span v-else class="thumb icon"></span>

				<p class="client">{{ notify.senderName }}</p>
				<div class="message">{{ notify.showMsgContent }}</div>
			</template>

			<div v-else class="single-message">{{ notify.showMsgContent }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'notifyMe',
	data () {
		return {}
	},
	computed: {
		notify () {
			return this.$store.state.notify;
		}
	},
	methods: {
		// 关闭提示框
		closeNotify () {
			var self = this;
			self.$store.commit('changeNotify', '');
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/notifyMe.vue